export default __webpack_public_path__ + "static/media/naidi-1-3.1c4af252.svg";